import PeriodicosExamDrawer from './PeriodicosExamDrawer';
import PeriodicosPrestadorDrawer from './PeriodicosPrestadorDrawer';
import { DrawerContainer } from '../../../components/Drawer/DrawerContainer';
import PeriodicosGenerateConvocatoriaDrawer from './PeriodicosGenerateConvocatoriaDrawer';
import PeriodicosAsignarTurnoDrawer from './PeriodicosAsignarTurnoDrawer';
import PeriodicosExamAndPrestadorDrawer from './PeriodicosExamAndPrestadorDrawer';
import PeriodicosAsignarResultadoDrawer from './PeriodicosAsignarResultadoDrawer';

import PeriodicosReconfirmationExamDrawer from './drawers/reconfirmation/PeriodicosReconfirmationExamDrawer';
import PeriodicosResultadosDetailsHistoryDrawer from './drawers/results/PeriodicosResultadosDetailsHistoryDrawer';
import { HistoryDrawer } from './drawers/batch/HistoryDrawer';
import { PeriodicosAssignPrestadorDrawer } from './PeriodicosAssignPrestadorDrawer';
import { PeriodicosMedicalAuditDrawer } from './drawers/results/PeriodicosMedicalAuditDrawer';
import { PeriodicosResultsUploadDrawer } from './drawers/results/PeriodicosResultsUploadDrawer';
import { AsistenciaDrawer } from './drawers/batch/AsistenciaDrawer';
import { PeriodicosCreateReconfirmationBatchDrawer } from './drawers/batch/PeriodicosCreateReconfirmationBatchDrawer';
import { Batch } from '../types/PeriodicosTypes';

export const PERIODICOS_DRAWER_ACTION_VALUES = {
    ASSIGN_EXAM: 'assign-exam',
    OLD_ASSIGN_PRESTADOR: 'old-assign-prestador',
    MASSIVE_ASSIGN_PRESTADOR: 'massive-assign-prestador',
    SINGLE_ASSIGN_PRESTADOR: 'single-assign-prestador',
    GENERATE_CONVOCATORIA: 'generate-convocatoria',
    ASSIGN_SHIFT: 'assign-shift',
    ASSIGN_EXAM_AND_PRESTADOR: 'assign-exam-and-prestador',
    ASSIGN_RESULTS: 'generate-results',
    GENERATE_CONVOCATED: 'generate-convocated',
    SEE_CONVOCATED: 'see-convocated',
    RECONFIRMATION: {
        ASSIGN_EXAM: 'reconfirmation-assign-exam'
    },
    VIEW_DETAILS_HISTORY: 'see-details',
    BATCH_EMPLOYEE_HISTORY: 'batch-employee-history',
    MEDICAL_AUDIT: 'medical-audit',
    BATCH_EMPLOYEE_ASSISTANCE: 'batch-employee-assistance',
    CHANGE_PRESTADOR: 'change-prestador',
    CREATE_RECONFIRMATION_BATCH: 'create-reconfirmation-batch',
    UPLOAD_RESULTS: 'upload-results'
};

interface PeriodicosDrawerManagerProps {
    open: string;
    setOpen: (state: string) => void;
    selectedIds?: string[];
    reloadGrid?: () => void;
    selectedBatch?: Batch | null;
    selectedEmployee?: {
        nombre?: string;
        riesgo?: { id: number; codigo: any } | { id: number; codigo: any }[];
    };
    selectedEmployees?: any[];
    reloadCurrentTab?: () => void;
    tabIndex?: number;
    reconfirmation?: boolean;
    selectedBatches?: Batch[];
    handleMarkEmployeeAttendanceClick?: (
        attendanceStatus: string,
        selectedEmployees?: any[]
    ) => Promise<boolean>;
    isUpdatingAttendance?: boolean;
    selectedBatchId?: number | null;
    handleAssignShiftClick?: (turnDate: any, selectedEmployees: any[]) => Promise<boolean>;
    isAssigningShift?: boolean;
    onAssignPrestadorSuccess?: () => void;
}
const PeriodicosDrawerManager = ({
    open,
    setOpen,
    selectedIds = [],
    reloadGrid = () => {},
    selectedEmployee,
    selectedEmployees = [],
    reloadCurrentTab = () => {},
    selectedBatch = null,
    tabIndex = 0,
    reconfirmation = false,
    selectedBatches = [],
    handleMarkEmployeeAttendanceClick,
    isUpdatingAttendance = false,
    selectedBatchId = null,
    handleAssignShiftClick,
    isAssigningShift = false,
    onAssignPrestadorSuccess
}: PeriodicosDrawerManagerProps) => {
    const employeeRisk = Array.isArray(selectedEmployee?.riesgo)
        ? selectedEmployee?.riesgo.map((r) => r.codigo).join(', ')
        : selectedEmployee?.riesgo?.codigo || '';

    const handleCloseDrawer = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        setOpen('');
    };

    const renderDrawerContent = () => {
        switch (open) {
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_EXAM:
                return (
                    <PeriodicosExamDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.OLD_ASSIGN_PRESTADOR:
                return (
                    <PeriodicosPrestadorDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        employeeName={selectedEmployee?.nombre || ''}
                        employeeRisk={employeeRisk}
                        selectedEmployee={selectedEmployee}
                        reconfirmation={reconfirmation}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.MASSIVE_ASSIGN_PRESTADOR:
                return (
                    <PeriodicosAssignPrestadorDrawer
                        selectedBatch={selectedBatch}
                        closeDrawer={handleCloseDrawer}
                        isMassiveAssignation={true}
                        isReassignation={false}
                        selectedBatches={selectedBatches}
                        onSuccess={onAssignPrestadorSuccess}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.SINGLE_ASSIGN_PRESTADOR:
                return (
                    <PeriodicosAssignPrestadorDrawer
                        selectedBatch={selectedBatch}
                        closeDrawer={handleCloseDrawer}
                        isMassiveAssignation={false}
                        isReassignation={false}
                        selectedBatches={selectedBatches}
                        onSuccess={onAssignPrestadorSuccess}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.GENERATE_CONVOCATORIA:
                return (
                    <PeriodicosGenerateConvocatoriaDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        reconfirmation={reconfirmation}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_SHIFT:
                return (
                    <PeriodicosAsignarTurnoDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        selectedEmployee={selectedEmployee}
                        selectedEmployees={selectedEmployees}
                        reloadCurrentTab={reloadCurrentTab}
                        tabIndex={tabIndex}
                        reconfirmation={reconfirmation}
                        handleAssignShift={handleAssignShiftClick}
                        isAssigningShift={isAssigningShift}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_RESULTS:
                return (
                    <PeriodicosAsignarResultadoDrawer
                        selectedIds={selectedIds}
                        setOpen={handleCloseDrawer}
                        reloadGrid={reloadGrid}
                        selectedEmployee={selectedEmployee}
                        isReconfirmation={reconfirmation}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.ASSIGN_EXAM_AND_PRESTADOR:
                return (
                    <PeriodicosExamAndPrestadorDrawer
                        setOpen={handleCloseDrawer}
                        employeeName={selectedEmployee?.nombre || ''}
                        employeeRisk={employeeRisk}
                        selectedEmployee={selectedEmployee}
                        reloadGrid={reloadGrid}
                        reconfirmation={reconfirmation}
                    />
                );

            case PERIODICOS_DRAWER_ACTION_VALUES.RECONFIRMATION.ASSIGN_EXAM:
                return (
                    <PeriodicosReconfirmationExamDrawer
                        setOpen={handleCloseDrawer}
                        selectedEmployee={selectedEmployee}
                        selectedIds={selectedIds}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.VIEW_DETAILS_HISTORY:
                return (
                    <PeriodicosResultadosDetailsHistoryDrawer
                        setOpen={handleCloseDrawer}
                        selectedEmployee={selectedEmployee}
                    />
                );

            case PERIODICOS_DRAWER_ACTION_VALUES.BATCH_EMPLOYEE_HISTORY:
                return (
                    <HistoryDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedEmployee={selectedEmployee}
                        selectedBatchId={selectedBatchId}
                    />
                );

            case PERIODICOS_DRAWER_ACTION_VALUES.MEDICAL_AUDIT:
                return (
                    <PeriodicosMedicalAuditDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedEmployee={selectedEmployee}
                        selectedBatchId={selectedBatchId}
                        selectedBatch={selectedBatch}
                    />
                );

            case PERIODICOS_DRAWER_ACTION_VALUES.BATCH_EMPLOYEE_ASSISTANCE: {
                const resolvedEmployeesForAttendance =
                    selectedEmployees.length > 0
                        ? selectedEmployees
                        : selectedEmployee
                          ? [selectedEmployee]
                          : [];

                return (
                    <AsistenciaDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedEmployees={resolvedEmployeesForAttendance}
                        handleMarkAsistencia={(attendanceStatus: string) =>
                            handleMarkEmployeeAttendanceClick
                                ? handleMarkEmployeeAttendanceClick(
                                      attendanceStatus,
                                      resolvedEmployeesForAttendance
                                  )
                                : Promise.resolve(false)
                        }
                        isLoading={isUpdatingAttendance}
                    />
                );
            }
            case PERIODICOS_DRAWER_ACTION_VALUES.CHANGE_PRESTADOR:
                return (
                    <PeriodicosAssignPrestadorDrawer
                        selectedBatch={selectedBatch}
                        closeDrawer={handleCloseDrawer}
                        isMassiveAssignation={false}
                        isReassignation={true}
                        selectedBatches={selectedBatches}
                        onSuccess={onAssignPrestadorSuccess}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.CREATE_RECONFIRMATION_BATCH:
                return (
                    <PeriodicosCreateReconfirmationBatchDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedBatchId={selectedBatchId}
                    />
                );
            case PERIODICOS_DRAWER_ACTION_VALUES.UPLOAD_RESULTS:
                return (
                    <PeriodicosResultsUploadDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedEmployee={selectedEmployee}
                        selectedBatch={selectedBatch}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer
            open={!!open}
            setOpen={setOpen}
            customWidth={
                open === PERIODICOS_DRAWER_ACTION_VALUES.MEDICAL_AUDIT ? 1000 :
                open === PERIODICOS_DRAWER_ACTION_VALUES.CREATE_RECONFIRMATION_BATCH ? 560 :
                open === PERIODICOS_DRAWER_ACTION_VALUES.UPLOAD_RESULTS ? 1000 :
                480
            }
        >
            {renderDrawerContent()}
        </DrawerContainer>
    );
};

export default PeriodicosDrawerManager;
